import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "Me pregunto en silencio";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la preocupación",
    opening: localizedGenderNode(
      [
        "Hay días en que siempre hay algo por qué preocuparse.",
        "Si no es esto,",
        "entonces es otra cosa.",
        "Algo en el trabajo.",
        "Algo en casa.",
        "Algo en el cuerpo.",
        "Como si mi mente no quisiera descansar",
        "hasta que todo esté en orden.",
        "Pero por dentro solo me canso más.",
      ],
      [
        "Hay días en que siempre hay algo por qué preocuparse.",
        "Si no es esto,",
        "entonces es otra cosa.",
        "Algo en el trabajo.",
        "Algo en casa.",
        "Algo en el cuerpo.",
        "Como si mi mente no quisiera descansar",
        "hasta que todo esté en orden.",
        "Pero por dentro solo me canso más.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["Pausa.", "No estoy resolviendo todo ahora.", "Solo noto que la preocupación ya está aquí."],
      ["Pausa.", "No estoy resolviendo todo ahora.", "Solo noto que la preocupación ya está aquí."]
    ),
    prompts: localizedGenderNode(
      [
        "¿Qué es lo que más me preocupa hoy?",
        "¿Qué sube con ella en mi cuerpo?",
        "¿Qué frase se repite por dentro?",
      ],
      [
        "¿Qué es lo que más me preocupa hoy?",
        "¿Qué sube con ella en mi cuerpo?",
        "¿Qué frase se repite por dentro?",
      ]
    ),
    closing: localizedGenderNode(
      ["La preocupación está aquí.", "Ya no corro con ella sin darme cuenta."],
      ["La preocupación está aquí.", "Ya no corro con ella sin darme cuenta."]
    ),
    action: localizedGenderNode(
      "Hoy me detengo un momento cuando me doy cuenta de que vuelvo a preocuparme.",
      "Hoy me detengo un momento cuando me doy cuenta de que vuelvo a preocuparme."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer disparador",
    opening: localizedGenderNode([
      "A veces empieza muy pequeño.",
      "Un mensaje que no llegó.",
      "Silencio.",
      "Algo que quedó pendiente.",
      "Y ya estoy dentro.",
    ]),
    mindfulness: localizedGenderNode([
      "Me quedo un momento justo al principio.",
      "Antes de que se me llene la cabeza.",
    ]),
    prompts: localizedGenderNode(
      [
        "¿Qué pasó justo antes de que subiera la preocupación?",
        "¿A qué hora del día me entra más rápido?",
        "¿Qué intento evitar en ese momento?",
      ],
      [
        "¿Qué pasó justo antes de que subiera la preocupación?",
        "¿A qué hora del día me entra más rápido?",
        "¿Qué intento evitar en ese momento?",
      ]
    ),
    closing: localizedGenderNode(
      ["Vi el momento en que empezó.", "Eso me da un poco de espacio."],
      ["Vi el momento en que empezó.", "Eso me da un poco de espacio."]
    ),
    action: localizedGenderNode(
      "Hoy presto atención al primer momento en que se enciende.",
      "Hoy presto atención al primer momento en que se enciende."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
        "Antes de entender de qué me preocupo,",
        "mi cuerpo ya se tensó.",
        "Los hombros suben.",
        "La barriga se aprieta.",
        "La respiración se vuelve corta.",
      ],
      [
        "Antes de entender de qué me preocupo,",
        "mi cuerpo ya se tensó.",
        "Los hombros suben.",
        "La barriga se aprieta.",
        "La respiración se vuelve corta.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["Siento dónde se instala.", "No le añado más presión a mi cuerpo ahora."],
      ["Siento dónde se instala.", "No le añado más presión a mi cuerpo ahora."]
    ),
    prompts: localizedGenderNode(
      [
        "¿Dónde se instala la preocupación en mi cuerpo?",
        "¿De qué intenta protegerme mi cuerpo ahí?",
        "¿Qué podría aflojar un poco ahora?",
      ],
      [
        "¿Dónde se instala la preocupación en mi cuerpo?",
        "¿De qué intenta protegerme mi cuerpo ahí?",
        "¿Qué podría aflojar un poco ahora?",
      ]
    ),
    closing: localizedGenderNode(
      ["Mi cuerpo carga con mucha de esta preocupación.", "Hoy no la ignoro."],
      ["Mi cuerpo carga con mucha de esta preocupación.", "Hoy no la ignoro."]
    ),
    action: localizedGenderNode(
      "Hoy me quedo un momento con lo que siente mi cuerpo, sin empujar.",
      "Hoy me quedo un momento con lo que siente mi cuerpo, sin empujar."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historias de preocupación",
    opening: localizedGenderNode([
      "Muy rápido la preocupación se vuelve historia.",
      "No solo lo que pasó,",
      "sino todo lo que todavía podría pasar.",
      "Y ya estoy reaccionando a algo",
      "que ni siquiera ha pasado.",
    ]),
    mindfulness: localizedGenderNode([
      "Me detengo entre lo que hay",
      "y todo lo que ya imaginé.",
    ]),
    prompts: localizedGenderNode(
      [
        "¿Qué escena me salta primero?",
        "¿Qué de eso me asusta más?",
        "¿Qué más podría ser cierto aquí además de esa historia?",
      ],
      [
        "¿Qué escena me salta primero?",
        "¿Qué de eso me asusta más?",
        "¿Qué más podría ser cierto aquí además de esa historia?",
      ]
    ),
    closing: localizedGenderNode(
      ["Vi la historia saltar.", "Eso ya me frena un poco."],
      ["Vi la historia saltar.", "Eso ya me frena un poco."]
    ),
    action: localizedGenderNode(
      "Hoy me digo una vez: aún no ha pasado todo.",
      "Hoy me digo una vez: aún no ha pasado todo."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "De qué se disfraza la preocupación",
    opening: localizedGenderNode([
      "A veces el tema cambia,",
      "pero la sensación se queda.",
      "Hoy es el dinero.",
      "Mañana, la salud.",
      "Luego alguien que no respondió.",
      "Como si la preocupación solo buscara en qué vestirse.",
    ]),
    mindfulness: localizedGenderNode([
      "Noto cómo cambia de forma,",
      "pero sigue la misma presión.",
    ]),
    prompts: localizedGenderNode(
      [
        "¿De qué me preocupo ahora?",
        "¿Qué tema vuelve más?",
        "¿Qué me gustaría sentir en lugar de todo esto?",
      ],
      [
        "¿De qué me preocupo ahora?",
        "¿Qué tema vuelve más?",
        "¿Qué me gustaría sentir en lugar de todo esto?",
      ]
    ),
    closing: localizedGenderNode(
      ["Vi que la preocupación no descansa de verdad.", "Solo cambia de tema."],
      ["Vi que la preocupación no descansa de verdad.", "Solo cambia de tema."]
    ),
    action: localizedGenderNode(
      "Hoy escribo una palabra de lo que más me agarró.",
      "Hoy escribo una palabra de lo que más me agarró."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "El bucle que vuelve",
    opening: localizedGenderNode(
      [
        "Tengo un bucle que ya conozco.",
        "Pensar.",
        "Revisar.",
        "Volver otra vez.",
        "Intentar calmarme.",
        "Y otra vez pensar.",
        "Al final solo estoy agotado.",
      ],
      [
        "Tengo un bucle que ya conozco.",
        "Pensar.",
        "Revisar.",
        "Volver otra vez.",
        "Intentar calmarme.",
        "Y otra vez pensar.",
        "Al final solo estoy agotada.",
      ]
    ),
    mindfulness: localizedGenderNode([
      "Veo este bucle mientras pasa.",
      "No solo después.",
    ]),
    prompts: localizedGenderNode(
      [
        "¿Cuál es el bucle que se repite en mí una y otra vez?",
        "¿Cómo suele empezar?",
        "¿Cómo me siento cuando pasa?",
      ],
      [
        "¿Cuál es el bucle que se repite en mí una y otra vez?",
        "¿Cómo suele empezar?",
        "¿Cómo me siento cuando pasa?",
      ]
    ),
    closing: localizedGenderNode(
      ["Es un bucle.", "No todo lo que soy."],
      ["Es un bucle.", "No todo lo que soy."]
    ),
    action: localizedGenderNode(
      "Hoy me digo una vez: estoy dentro del bucle.",
      "Hoy me digo una vez: estoy dentro del bucle."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "La necesidad de fondo",
    opening: localizedGenderNode(
      [
        "Debajo de tanta preocupación",
        "también hay algo que pido.",
        "Sentirme seguro.",
        "Sentir que alguien sostiene.",
        "Sentir que no todo se va a caer",
        "si suelto un momento.",
      ],
      [
        "Debajo de tanta preocupación",
        "también hay algo que pido.",
        "Sentirme segura.",
        "Sentir que alguien sostiene.",
        "Sentir que no todo se va a caer",
        "si suelto un momento.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["Escucho lo que realmente necesito ahora."],
      ["Escucho lo que realmente necesito ahora."]
    ),
    prompts: localizedGenderNode(
      [
        "¿Qué busco de verdad bajo esta preocupación?",
        "¿Qué intento proteger?",
        "¿Cómo se siente cuando tengo un poco de seguridad?",
      ],
      [
        "¿Qué busco de verdad bajo esta preocupación?",
        "¿Qué intento proteger?",
        "¿Cómo se siente cuando tengo un poco de seguridad?",
      ]
    ),
    closing: localizedGenderNode(
      ["Tengo una necesidad real de seguridad.", "No tengo que pelear con ella."],
      ["Tengo una necesidad real de seguridad.", "No tengo que pelear con ella."]
    ),
    action: localizedGenderNode(
      "Hoy me doy un momento de calma sin resolver todo.",
      "Hoy me doy un momento de calma sin resolver todo."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "Estar con la incertidumbre",
    opening: localizedGenderNode(
      [
        "Lo más duro es no saber.",
        "No saber si se va a resolver.",
        "No saber si va a pasar.",
        "No saber si me pierdo algo.",
        "Y entonces mi cabeza corre",
        "solo para no sentir eso.",
      ],
      [
        "Lo más duro es no saber.",
        "No saber si se va a resolver.",
        "No saber si va a pasar.",
        "No saber si me pierdo algo.",
        "Y entonces mi cabeza corre",
        "solo para no sentir eso.",
      ]
    ),
    mindfulness: localizedGenderNode([
      "Me quedo un momento con lo que no está cerrado.",
      "Solo un momento.",
    ]),
    prompts: localizedGenderNode(
      [
        "¿Qué es lo más incierto para mí ahora?",
        "¿Qué me cuesta soportar en eso?",
        "¿Qué frase amable podría ayudarme a aguantar un momento?",
      ],
      [
        "¿Qué es lo más incierto para mí ahora?",
        "¿Qué me cuesta soportar en eso?",
        "¿Qué frase amable podría ayudarme a aguantar un momento?",
      ]
    ),
    closing: localizedGenderNode(
      ["La incertidumbre todavía me cuesta.", "Pero tal vez no tengo que huir de ella enseguida."],
      ["La incertidumbre todavía me cuesta.", "Pero tal vez no tengo que huir de ella enseguida."]
    ),
    action: localizedGenderNode(
      "Hoy me detengo un momento antes de correr a buscar certeza.",
      "Hoy me detengo un momento antes de correr a buscar certeza."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "Una voz interior más suave",
    opening: localizedGenderNode(
      [
        "Cuando me preocupo,",
        "también empiezo a hablarme duro.",
        "Como si apretándome lo suficiente",
        "conseguiré calmarme.",
        "Pero por dentro solo me contrae más.",
      ],
      [
        "Cuando me preocupo,",
        "también empiezo a hablarme duro.",
        "Como si apretándome lo suficiente",
        "conseguiré calmarme.",
        "Pero por dentro solo me contrae más.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["Oigo cómo me hablo en estos momentos."],
      ["Oigo cómo me hablo en estos momentos."]
    ),
    prompts: localizedGenderNode(
      [
        "¿Cómo me hablo cuando me preocupo?",
        "¿Qué me gustaría oír en lugar de eso?",
        "¿Qué frase más suave quiero probar?",
      ],
      [
        "¿Cómo me hablo cuando me preocupo?",
        "¿Qué me gustaría oír en lugar de eso?",
        "¿Qué frase más suave quiero probar?",
      ]
    ),
    closing: localizedGenderNode(
      ["Mi tono lo cambia todo.", "Quiero recordar eso."],
      ["Mi tono lo cambia todo.", "Quiero recordar eso."]
    ),
    action: localizedGenderNode(
      "Hoy me digo una frase un poco más suave.",
      "Hoy me digo una frase un poco más suave."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Soltar un momento",
    opening: localizedGenderNode(
      [
        "Tal vez no tengo que sostener",
        "toda esta preocupación en las manos ahora.",
        "Tal vez puedo soltarla un momento.",
        "No para siempre.",
        "Solo un momento.",
      ],
      [
        "Tal vez no tengo que sostener",
        "toda esta preocupación en las manos ahora.",
        "Tal vez puedo soltarla un momento.",
        "No para siempre.",
        "Solo un momento.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["Me doy un momento pequeño sin sostenerlo todo."],
      ["Me doy un momento pequeño sin sostenerlo todo."]
    ),
    prompts: localizedGenderNode(
      [
        "¿Qué pasa en mí cuando suelto la preocupación un momento?",
        "¿Qué me asusta de soltar?",
        "¿Qué me calma aunque sea un poco?",
      ],
      [
        "¿Qué pasa en mí cuando suelto la preocupación un momento?",
        "¿Qué me asusta de soltar?",
        "¿Qué me calma aunque sea un poco?",
      ]
    ),
    closing: localizedGenderNode(
      ["La solté un momento.", "El mundo no se vino abajo por eso."],
      ["La solté un momento.", "El mundo no se vino abajo por eso."]
    ),
    action: localizedGenderNode(
      "Hoy me doy un momento sin seguir el pensamiento.",
      "Hoy me doy un momento sin seguir el pensamiento."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "Volver al presente",
    opening: localizedGenderNode([
      "La preocupación siempre me tira hacia adelante.",
      "A lo que puede pasar pronto.",
      "A lo que podría pasar.",
      "Pero ahora también está este momento.",
      "La habitación.",
      "La silla.",
      "La respiración.",
      "Mi cuerpo aquí.",
    ]),
    mindfulness: localizedGenderNode(
      ["Vuelvo a lo que hay alrededor y dentro de mí ahora."],
      ["Vuelvo a lo que hay alrededor y dentro de mí ahora."]
    ),
    prompts: localizedGenderNode(
      [
        "¿Qué oigo ahora?",
        "¿Qué veo alrededor?",
        "¿Qué siento en este preciso momento?",
      ],
      [
        "¿Qué oigo ahora?",
        "¿Qué veo alrededor?",
        "¿Qué siento en este preciso momento?",
      ]
    ),
    closing: localizedGenderNode(
      ["Este momento me devuelve un poco a tierra."],
      ["Este momento me devuelve un poco a tierra."]
    ),
    action: localizedGenderNode(
      "Hoy noto mis pies en el suelo un momento.",
      "Hoy noto mis pies en el suelo un momento."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "Antes de buscar certeza",
    opening: localizedGenderNode([
      "Tengo una necesidad de saber ahora.",
      "De revisar ahora.",
      "De tranquilizarme ahora.",
      "Pero a veces es esa misma búsqueda",
      "la que mantiene viva la preocupación.",
    ]),
    mindfulness: localizedGenderNode([
      "Me detengo un momento antes de correr a revisar.",
    ]),
    prompts: localizedGenderNode(
      [
        "¿Qué quiero saber ahora?",
        "¿Qué pasaría si no supiera enseguida?",
        "¿Qué podría ayudarme a esperar un momento?",
      ],
      [
        "¿Qué quiero saber ahora?",
        "¿Qué pasaría si no supiera enseguida?",
        "¿Qué podría ayudarme a esperar un momento?",
      ]
    ),
    closing: localizedGenderNode(
      ["Esperé un momento.", "Eso ya cambia algo."],
      ["Esperé un momento.", "Eso ya cambia algo."]
    ),
    action: localizedGenderNode(
      "Hoy me detengo un momento antes de una revisión.",
      "Hoy me detengo un momento antes de una revisión."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "Un paso pequeño",
    opening: localizedGenderNode(
      [
        "No necesito resolver toda mi vida",
        "para sentirme un poco mejor.",
        "Necesito un paso pequeño.",
        "Uno que de verdad pueda dar.",
      ],
      [
        "No necesito resolver toda mi vida",
        "para sentirme un poco mejor.",
        "Necesito un paso pequeño.",
        "Uno que de verdad pueda dar.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["Siento qué paso pequeño me es posible hoy."],
      ["Siento qué paso pequeño me es posible hoy."]
    ),
    prompts: localizedGenderNode(
      [
        "¿Qué en mí está listo para elegir algo pequeño?",
        "¿Cuándo me parece posible?",
        "¿Qué me gustaría recordar en un momento difícil?",
      ],
      [
        "¿Qué en mí está listo para elegir algo pequeño?",
        "¿Cuándo me parece posible?",
        "¿Qué me gustaría recordar en un momento difícil?",
      ]
    ),
    closing: localizedGenderNode(
      ["Elegí algo pequeño.", "Basta por hoy."],
      ["Elegí algo pequeño.", "Basta por hoy."]
    ),
    action: localizedGenderNode(
      "Hoy me quedo con el paso pequeño que elegí.",
      "Hoy me quedo con el paso pequeño que elegí."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Una frase para volver",
    opening: localizedGenderNode(
      [
        "La preocupación va a volver a veces.",
        "Lo sé.",
        "Pero ya la conozco un poco mejor.",
        "Y no tengo que ir con ella hasta el final cada vez.",
      ],
      [
        "La preocupación va a volver a veces.",
        "Lo sé.",
        "Pero ya la conozco un poco mejor.",
        "Y no tengo que ir con ella hasta el final cada vez.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["Respiro y vuelvo a mí."],
      ["Respiro y vuelvo a mí."]
    ),
    prompts: localizedGenderNode(
      [
        "¿Qué he aprendido de esta preocupación?",
        "¿Cuál es la primera señal de que sube?",
        "¿Qué frase corta quiero llevar conmigo?",
      ],
      [
        "¿Qué he aprendido de esta preocupación?",
        "¿Cuál es la primera señal de que sube?",
        "¿Qué frase corta quiero llevar conmigo?",
      ]
    ),
    closing: localizedGenderNode(
      ["Sigo desde aquí con un poco más de espacio."],
      ["Sigo desde aquí con un poco más de espacio."]
    ),
    action: localizedGenderNode(
      "Hoy me guardo una frase corta que me devuelve a mí.",
      "Hoy me guardo una frase corta que me devuelve a mí."
    ),
  },
].map(buildNormalizedDay);

export const anxietyGeneralBlueprintEs = buildNormalizedPilotBlueprint({
  id: "anxiety_general_14d",
  durationDays: 14,
  version: "normalizer_phase2_batch_01_v1",
  problemKey: "anxiety_general",
  category: "anxiety",
  journeyName: {
    he: "דאגנות יתר בכל נושא",
    en: "Excessive worry about everything",
    es: "Preocupación excesiva por todo",
  },
  days,
});

export default anxietyGeneralBlueprintEs;
